import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    actionCellsLabel:
      "You don't have this document? Download one of our templates:",
    csvDescription: 'Compatible with Excel, Google Sheet etc.',
    description:
      '' +
      'For your document to be accepted, make sure that it contains a maximum of **100 transfers in euros**. ' +
      'Each transfer **must not exceed €10,000**. ' +
      'The IBANs of your beneficiaries must be **SEPA** compatible.',
    pageTitle: 'Bulk Transfer',
    title: 'Send your document',
    uploadError:
      'An error occurred while uploading your file. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    xmlDescription: 'Compatible with any text editor.',
  },
  fr: {
    actionCellsLabel:
      'Vous n’avez pas ce document\xA0? Téléchargez un de nos modèles\xA0:',
    csvDescription: 'Compatible avec Excel, Google Sheet etc.',
    description:
      '' +
      'Pour que votre document soit accepté, assurez-vous qu’il contienne ' +
      'maximum **100 virements en euros**. Chaque virement ne doit **pas excéder 10\xA0' +
      '000\xA0€**. Les IBAN de vos bénéficiaires doivent être compatibles **SEPA**.',
    pageTitle: 'Virement groupé',
    title: 'Ajoutez votre document',
    uploadError:
      'Une erreur est survenue en ajoutant votre fichier. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    xmlDescription: 'Compatible avec tous les éditeurs de texte.',
  },
} as const);
